import {
  styled,
  TableCell,
} from "@mui/material";
import TooltipCell from "controls/global/stewart-table/TooltipCell";
import React from "react";
import {
  borderSize,
  colors,
  fontSize,
  fontWeight,
  padding,
} from "theme/defaultStyle";
import theme from "theme/default";

const StyledTableFooterCell = styled(TableCell)({
  borderBottom: "none",
  borderTop: `${borderSize.xsmall} solid ${colors.black}`,
  color: colors.black,
  fontSize: fontSize.xlarge1,
  fontWeight: fontWeight.bold1,
  maxWidth: "170px",
  overflow: "hidden",
  paddingRight: padding.large1,
  paddingTop: padding.small2,
  textOverFlow: "ellipses",
  "&.normalPadding": {
    paddingBottom: padding.xsmall2,
    paddingTop: padding.small2,
  },
  "&.bigPadding": {
    paddingBottom: padding.large1,
    paddingTop: padding.large1,
  },
});

const RiskRateTotalCell = styled(TooltipCell)({
  "&.totalDueNoUnderline": {
    color: colors.grey11,
    display: "inline-block",
    maxWidth: "100%",
    // NOTE: There is an underlying HTML issue where we can not always detect
    // when an ellipsis is shown due to clientWidth and scrollWidth values being rounded
    // before being returned to us.
    // https://github.com/w3c/csswg-drafts/issues/4123
    [theme.breakpoints.between("lg", 1921)]: { // NOTE: xl breakpoint + 1.
      marginRight: "1px",
    },
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  "&.totalDueWhiteUnderline": {
    borderBottom: "none !important",
    display: "inline-block",
    maxWidth: "100%",
    // NOTE: There is an underlying HTML issue where we can not always detect
    // when an ellipsis is shown due to clientWidth and scrollWidth values being rounded
    // before being returned to us.
    // https://github.com/w3c/csswg-drafts/issues/4123
    [theme.breakpoints.between("lg", 1921)]: { // NOTE: xl breakpoint + 1.
      marginRight: "1px",
    },
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
});

type Props = {
  riskRateTotal: string;
  hasIssuedProducts: boolean;
  hasFileLockedWithUpdateablePricingItem: boolean;
};

export default function RiskRateTotal({ riskRateTotal, hasIssuedProducts, hasFileLockedWithUpdateablePricingItem }: Props) {

  const footerCellClassname = hasFileLockedWithUpdateablePricingItem
    ? "normalPadding"
    : "bigPadding";

  const totalClassname = hasFileLockedWithUpdateablePricingItem
    ? "totalDueNoUnderline"
    : "totalDueWhiteUnderline";

  return (
    <StyledTableFooterCell
      align="right"
      className={footerCellClassname}
    >
      {hasIssuedProducts &&
        <RiskRateTotalCell
          className={totalClassname}
          title={riskRateTotal}
        />
      }
    </StyledTableFooterCell>
  );
}
